import { Logger } from '../../02_utils/logger';
import { Utils } from '../../02_utils/utils';

export class Navigation {
  private navigation: HTMLElement = document.querySelector('.js-l-navigation');
  private openButton: HTMLElement = document.querySelector('.js-l-navigation__open');
  private closeButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-l-navigation__close');
  private backdrop: HTMLElement = document.querySelector('.js-panel-backdrop');

  constructor(private $log: Logger, private $utils: Utils) {
    this.$log.log('Navigation:', this.navigation);

    if (this.navigation) {
      this.initNavigation();
      this.openNavigationEvent();
      this.closeNavigationEvent();
    }
  }

  public initNavigation(): void {
    // Search all navigation links
    const navigationLinks: NodeListOf<HTMLElement> = this.navigation.querySelectorAll('.js-l-navigation__link');
    navigationLinks.forEach((link: HTMLElement) => {
      this.linkClickEvent(link);
      document.addEventListener('base:navigation-close', () => {
        this.$utils.addOrRemoveClases('remove', 'active', link);
      });
      document.addEventListener('base:navigation-close-button', () => {
        this.$utils.addOrRemoveClases('remove', 'active', link);
      });
    });

    // Search all navigation back buttons
    const backButtons: NodeListOf<HTMLElement> = this.navigation.querySelectorAll('.js-l-navigation__level-back');
    backButtons.forEach((button: HTMLElement) => {
      this.navigationBackClickEvent(button);
    });

    // Open navigation call
    this.openButton?.addEventListener('click', () => {
      document.dispatchEvent(new Event('base:navigation-open'));
    }, { passive: true });

    // Close navigation call
    this.backdrop?.addEventListener('click', () => {
        document.dispatchEvent(new Event('base:navigation-close'));
      }, { passive: true });

    // Close navigation call
    this.closeButtons.forEach((closeButton: HTMLElement) => {
      closeButton?.addEventListener('click', () => {
          document.dispatchEvent(new Event('base:navigation-close'));
        }, { passive: true });
    });
  }

  private openNavigation(): void {
    const navigationLevel: HTMLElement = document.querySelector('.l-navigation__level-1');
    this.$utils.addOrRemoveClases('add', 'open', navigationLevel);
    this.$utils.addOrRemoveClases('add', 'modal-open', document.body);
  }

  private openNavigationEvent(): void {
    document.addEventListener('base:navigation-open', () => {
        this.$utils.activateFlyoutPanelBackdrop();
        this.openNavigation();
      }, { passive: true });
  }

  // Select all active classes within the navigation and removes them
  private closeNavigation(): void {
    const activeElements: NodeListOf<HTMLElement> = this.navigation.querySelectorAll('.open');
    activeElements.forEach((activeElement: HTMLElement) => {
      this.$utils.addOrRemoveClases('remove', 'open', activeElement);
    });
    this.$utils.addOrRemoveClases('remove', 'modal-open', document.body);
  }

  // Global custom event listener to close the navigation
  public closeNavigationEvent(): void {
    document.addEventListener('base:navigation-close', () => {
        this.$utils.deactivateFlyoutPanelBackdrop();
        this.closeNavigation();
        const backdropElement = document.querySelector('.js-panel-backdrop') as HTMLElement | null;
        backdropElement.classList.remove('backdropElement_clear')
      }, { passive: true });
  }

  // Handle click on navigation link
  private linkClickEvent(link: HTMLElement): void {
    link.addEventListener('click', (event) => {
      if (link.classList.contains('active')) {
        event.preventDefault();
        document.dispatchEvent(new Event('base:navigation-close'));
        return;
      }
      this.$utils.addOrRemoveClases('add', 'active', link);
      // If link(page) does not have children keep the normal link behavior
      if (!link.hasAttribute('data-link-more')) {
        return;
      }

      event.preventDefault();

      const pageId: Number = parseInt(link.dataset.pageId);
      const navigationLevel: HTMLElement = this.findNavigationLevel(pageId);

      this.removeOpenClass(pageId);

      if (navigationLevel) {
        this.setOpenClass(navigationLevel);
        this.$utils.activateFlyoutPanelBackdrop();
      }
    });
  }

  private navigationBackClickEvent(button: HTMLElement): void {
    button.addEventListener('click', () => {
        this.$utils.addOrRemoveClases('remove', 'open', button.parentElement?.parentElement?.parentElement);
        document.dispatchEvent(new Event('base:navigation-close-button'));
      }, { passive: true });
  }

  private findNavigationLevel(pageId: Number): HTMLElement {
    const navigationLevel: HTMLElement = this.navigation.querySelector(`div[data-page-parent-id="${pageId}"]`);
    return navigationLevel;
  }

  private setOpenClass(navigationLevel: HTMLElement): void {
    const navigationLevelPanel: HTMLElement = navigationLevel.parentElement;
    this.$utils.addOrRemoveClases('add', 'open', navigationLevel, navigationLevelPanel);
    this.$utils.addOrRemoveClases('add', 'js-panel-backdrop-element', navigationLevel, navigationLevelPanel);
    this.$utils.addOrRemoveClases('add', 'modal-open', document.body);
  }

  private removeOpenClass(pageId: Number): void {
    const navigationLevel: HTMLElement = this.navigation.querySelector(`div[data-page-parent-id="${pageId}"]`);
    const allNavigationLevelSiblings: NodeListOf<ChildNode> = navigationLevel.parentElement.childNodes;
    allNavigationLevelSiblings.forEach((navigationLevelSibling: ChildNode) => {
      if (navigationLevelSibling && (navigationLevelSibling as HTMLElement).classList) {
        this.$utils.addOrRemoveClases('remove', 'open', navigationLevelSibling as HTMLElement);
      }
    });
    this.$utils.addOrRemoveClases('remove', 'modal-open', document.body);
  }
}
